import Link from "@/src/common/components/Link"
import classNames from "classnames"
import React, { ReactNode } from "react"

const colorMapper = {
  black: "text-stears_black",
  white: "text-stears_white",
  blue: "text-accent-600"
}
type SimpleLinkProps = {
  color?: keyof typeof colorMapper
  href: string
  children: ReactNode
  onClick?: () => void
  forceAsInternalLink?: boolean
  newTab?: boolean
}

export const SimpleLink = (props: SimpleLinkProps) => {
  const colorCss = colorMapper[props.color || "black"]
  return (
    <Link
      href={props.href}
      className={classNames("text-btn_15 hover:underline text-xs", colorCss, {
        "force-as-internal-link": props.forceAsInternalLink
      })}
      onClick={props.onClick}
      target={props.newTab ? "_blank" : undefined}
      rel={props.newTab ? "noopener noreferrer" : undefined}
    >
      {props.children}
    </Link>
  )
}
